import React from 'react';
import { useAtom } from 'jotai';
import { atomRequestCustomerDetail } from '@/App';
import { ShowModal } from '@/model';
import { toLogin } from '@/config/request/login';
interface WithAuthProps {
    onClick?: () => void;
}
/*
 * import后作为标签直接包裹需要判断登录的元素使用
 *
 * 对于每一个子元素，如果它是一个有效的React元素，并且有onClick属性，
 * 那么就克隆这个元素，并给新元素的onClick属性赋值一个新的函数。
 * 这个新的函数会首先检查用户是否已经登录，如果没有登录，就跳转到登录页面，
 * 如果已经登录，就执行原本的onClick函数。
 */
const WithAuth = ({ children }) => {
    const [, writeShowModal] = useAtom(ShowModal.showModal);
    const [customerDetail] = useAtom(atomRequestCustomerDetail);
    const handleOnClick = (originalOnClick?: () => void) => {
        if (!customerDetail) {
            // window.location.href = toLogin(window.location.href);
            writeShowModal(true);
            return;
        }
        if (originalOnClick) {
            originalOnClick();
        }
    };
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement<WithAuthProps>(child)) {
            return React.cloneElement(child, {
                onClick: () => handleOnClick(child.props.onClick)
            });
        }
        return child;
    });
    return <>{childrenWithProps}</>;
};
export default WithAuth;
